<template>
  <div>
    <div class="tenant_title">
      房源查询
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="输入查询：">
        <el-input
          v-model="formInline.searchValue"
          placeholder="请输入客户姓名/地址/电话"
          clearable
        ></el-input>
      </el-form-item>
      <!-- 选择时间 -->
      <el-form-item label="时间检索：" class="left_margin">
        <el-date-picker
          v-model="time"
          value-format="yyyy-MM-dd"
          type="daterange"
          size="small"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="left"
          prefix-icon="el-icon-date"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="房型查询：" class="left_margin">
        <el-select
          v-model="formInline.roomNumber"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in roomNumber"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="房源类型：" class="left_margin">
        <el-select
          v-model="formInline.houseType"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in houseType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> </el-form-item
      ><br />
      <el-form-item label="金额查询：" class="money">
        <el-input
          v-model="money.moneyMin"
          placeholder="最低价"
          clearable
        ></el-input>
        <div class="zhi">至</div>
        <el-input
          v-model="money.moneyMax"
          placeholder="最高价"
          clearable
        ></el-input>
      </el-form-item>

<!--      <el-form-item label="所属公司：" class="left_margin">-->
<!--        <el-select v-model="formInline.company" clearable placeholder="请选择">-->
<!--          <el-option-->
<!--            v-for="item in company"-->
<!--            :key="item.value"-->
<!--            :label="item.label"-->
<!--            :value="item.value"-->
<!--          >-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <el-form-item class="left_margin">
        <el-button type="primary" @click="LandlordAjaxList" class="inquire"
          >搜索</el-button
        >
        <el-button type="primary" class="reset" @click="reset">重置</el-button>
        <!-- <el-button type="primary" class="newBtn" @click="newBtn"
          >新建</el-button
        >
        <el-button type="primary" class="mapBtn" @click="reset"
          >地图模式</el-button
        > -->
      </el-form-item>
    </el-form>
    <!-- <div class="newly_built">
      <el-button type="primary" class="export" @click="export_btn"
        >分配</el-button
      >
      <el-button type="primary" class="educe">导出</el-button>
    </div> -->
    <!-- 表单区域 -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="待审核" name="4"></el-tab-pane>
      <el-tab-pane label="审核失败" name="5"></el-tab-pane>
      <el-tab-pane label="审核通过" name="2"></el-tab-pane>
    </el-tabs>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>

      <el-table-column prop="houseId" label="房源编号"> </el-table-column>
      <el-table-column label="主图">
        <template slot-scope="scope">
          <div class="QuickMark" @click="getImg(scope.row)">
            <el-image
              style="width: 100%; height: 100%"
              :src="
                scope.row.houseInfoSon.vCoverPics
                  ? scope.row.houseInfoSon.vCoverPics[0]
                  : ''
              "
              :preview-src-list="srcList"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="vHousTitle" label="标题" width="280">
      </el-table-column>
      <el-table-column prop="houseFavour.mDailyPrice" label="价格">
      </el-table-column>
      <el-table-column label="房型" width="180">
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.roomNumber">{{ scope.row.roomNumber }}室</span
            ><span v-if="scope.row.hallNumber"
              >{{ scope.row.hallNumber }}厅</span
            ><span v-if="scope.row.bathroomNumber"
              >{{ scope.row.bathroomNumber }}卫</span
            ><span v-if="scope.row.kitchenNumber"
              >{{ scope.row.kitchenNumber }}厨</span
            ><span v-if="scope.row.balconyNumber"
              >{{ scope.row.balconyNumber }}阳台</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="city" label="房源地址"> </el-table-column>
      <el-table-column prop="houseInfoSon.iSameHourTotal" label="同类房源数">
      </el-table-column>
      <el-table-column label="房源状态">
        <template slot-scope="scope">
          <div v-if="scope.row.iHourseStatus == 0">
            已下架
          </div>
          <div v-if="scope.row.iHourseStatus == 3">待上线</div>
          <div v-if="scope.row.iHourseStatus == 4">审核失败</div>
          <div v-if="scope.row.iHourseStatus == 2">已上线</div>
        </template>
      </el-table-column>
      <el-table-column prop="onlineTime" label="上线时间"> </el-table-column>
      <el-table-column prop="customer.customerName" label="房东姓名">
      </el-table-column>
      <el-table-column prop="cHouSteward" label="房屋管家"> </el-table-column>
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="details(scope.row)"
            >查看</el-button
          ></template
        >
      </el-table-column>
    </el-table>
    <!-- <div class="checkBox"></div> -->
    <!-- 分页 -->
    <div class="paging">
      <div class="block">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 15, 20, 25]"
          :page-size="5"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新建弹出窗 -->
    <!-- <el-dialog title="选择房东" :visible.sync="dialogVisible" width="750px">
      <el-input
        placeholder="搜索姓名/手机号"
        prefix-icon="el-icon-search"
        v-model="searchValue"
        clearable
      >
      </el-input>
      <div class="landlord">
        <div class="landlord_title">
          <div>房东姓名</div>
          <div>手机号</div>
          <div>所属公司</div>
          <div>房屋管家</div>
        </div>

        <div
          class="title_list"
          v-for="(item, index) in HourseLoadlist"
          :key="index"
        >
          <div class="list">
            <el-radio
              v-model="radio"
              :label="index"
              @change="changeRadio(item)"
              >{{ item.customerName }}</el-radio
            >
          </div>

          <div class="list">{{ item.phonenumber | phone }}</div>
          <div class="list">{{ item.company }}</div>
          <div class="list">{{ item.cSteward }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" class="cancel"
          >取 消</el-button
        >
        <el-button type="primary" @click="goRental" class="add_new_btn"
          >确 定</el-button
        >
      </span>
    </el-dialog> -->
    <!-- 分配房东管家弹窗 -->
    <el-dialog
      :title="addtitleList"
      :visible.sync="dialogVisible_export"
      width="600px"
    >
      <div class="AddLabel" v-if="this.addtitleList == '选择部门'">
        <el-tag
          closable
          type="warning"
          :disable-transitions="false"
          @close="handleCloseTagOne(tag)"
        >
          11
        </el-tag>
      </div>
      <div class="select_list">
        <!-- 选择XX -->

        <div class="select_list_tree">
          <!-- 选择部门 -->
          <el-tree
            v-if="this.addtitleList == '选择部门'"
            accordion
            highlight-current
            :data="deptOptions"
            :props="defaultProps"
            @node-click="handleNodeClickTwo"
          ></el-tree>
        </div>
        <div class="select_list_tree_box"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_export = false" class="cancel"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="dialogVisible_export = false"
          class="add_new_btn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { money } from "../../utils/treating";
import {
  hourseAudit,
  TreeselectListsAjax,
  selectHourseLoadlist
} from "../../api/index";
export default {
  filters: {
    phone: function(item) {
      return item.substr(0, 3) + "****" + item.substr(7);
    }
  },
  data() {
    return {
      throttle: true,
      // 时间
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      addtitleList: "选择部门",
      // 客户id
      customerId: "",
      // 单选
      radio: "",
      // 搜索
      searchValue: "",
      // 新建弹窗
      dialogVisible: false,
      dialogVisible_export: false,
      // 房东列表
      defaultProps: {
        children: "children",
        label: "label"
      },
      HourseLoadlist: [],
      deptOptions: [],
      total: 0,
      currentPage: 1,
      // 消费金额
      money: {
        moneyMin: "",
        moneyMax: ""
      },
      // 搜索条件
      time: [],
      iHourseStatus: "4", //已下架 1：待上线 2：已上线 3：待审核
      formInline: {
        company: "",
        houseType: "",
        roomNumber: "",
        pageNum: 1,
        pageSize: 5,
        searchValue: undefined
      },
      srcList: [],
      tableData: [],
      company: [],
      roomNumber: [
        {
          value: 1,
          label: "1室"
        },
        {
          value: 2,
          label: "2室"
        },
        {
          value: 3,
          label: "3室"
        },
        {
          value: 4,
          label: "4室"
        },
        {
          value: 5,
          label: "5室"
        },
        {
          value: 6,
          label: "6室"
        },
        {
          value: 7,
          label: "7室"
        },
        {
          value: 8,
          label: "8+室"
        }
      ],

      houseType: [
        {
          value: 0,
          label: "个人房东"
        },
        {
          value: 1,
          label: "悠家自营房东"
        }
      ],
      activeName: "4"
    };
  },
  created() {
    this.LandlordAjaxList();
    // this.getTreeselectListsAjax();
  },
  methods: {
    onSubmit(e) {
      console.log(e);
    },
    reset() {
      this.formInline = {
        company: "",
        landlordType: "",
        roomNumber: "",
        pageNum: 1,
        pageSize: 5,
        searchValue: undefined
      };
      this.iHourseStatus = "4";
      this.time = [];
      this.money = {
        moneyMin: "",
        moneyMax: ""
      };
      this.LandlordAjaxList();
    },
    // 全选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 反选
    handleSelectionChange(val) {
      console.log(val);
    },
    // 获取表单数据
    async LandlordAjaxList() {
      if (!this.throttle) return;
      this.throttle = false;
      const { data: res } = await hourseAudit(
        money(this.formInline, this.money, this.time, this.iHourseStatus)
      );
      this.throttle = true;
      this.tableData = res.rows;
      this.total = res.total;
    },
    // 分页
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.LandlordAjaxList();
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val;
      this.LandlordAjaxList();
    },
    // 操作
    details(e) {
      console.log(e.houseId);
      this.$router.push({
        name: "HousingAudit", //跳转的路径
        params: {
          houseId: e.houseId
        }
      });
    },
    getImg(row) {
      console.log(row.houseInfoSon.vCoverPics);
      this.srcList.push(row.houseInfoSon.vCoverPics?.[0]);
    },
    // 获取树形结构数据
    async getTreeselectListsAjax() {
      const { data: res } = await TreeselectListsAjax();
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      var deptOptions = res.data;

      deptOptions.map(item => {
        var corporation = [];
        function foo(data) {
          if (data.level == "1") {
            if (corporation.indexOf(data) == -1) {
              corporation.push({
                value: item.id,
                label: item.label
              });
            }
          }
          if (data.children) {
            data.children.map(item => {
              if (item.level == 1) {
                corporation.push({
                  value: item.id,
                  label: item.label
                });
              }
              if (item.children) {
                foo(item);
              }
            });
          }
        }
        foo(item);
        this.company = corporation;
        let newArr = [];
        let obj = {};
        for (var i = 0; i < corporation.length; i++) {
          if (!obj[corporation[i].label]) {
            newArr.push(corporation[i]);
            obj[corporation[i].label] = true;
          }
        }
        this.company = newArr;
      });
    },
    changeRadio(e) {
      this.customerId = e.customerId;
    },
    goRental() {
      this.$router.push({
        name: "rental", //跳转的路径
        query: {
          customerId: this.customerId
        }
      });
    },
    handleClick(tab) {
      this.formInline.pageNum = 1;
      this.iHourseStatus = tab.name;
      console.log(this.formInline.pageNum);
      this.LandlordAjaxList();
    },
    // 分配
    export_btn() {
      this.dialogVisible_export = true;
    },
    // 新增树形
    handleNodeClickTwo(data) {
      this.inputValueList = data;
      this.inputValue = data.label;
      this.handleInputConfirm();
    },
    // Tag新增数据
    handleInputConfirm() {
      if (this.addtitleList == "选择部门") {
        var inputValue = this.inputValue;
        if (inputValue) {
          if (this.dynamicTagsOne.indexOf(this.inputValue) != -1) return;
          if (!this.inputValueList.children) {
            this.dynamicTagsOne = [];
            this.dynamicTagsOne.push(inputValue);
          }
        }
      }
      this.sizeForm.deptId = this.inputValue;
    }
  }
};
</script>

<style lang="less" scoped>
.tenant_title {
  width: 72px;
  height: 24px;
  font-size: 18px;
  line-height: 24px;
  color: #171a1e;
  margin-bottom: 20px;
}
/deep/.demo-form-inline {
  .el-input__inner {
    width: 220px;
    height: 36px;
    font-size: 14px;
  }
  .left_margin {
    margin-left: 26px;
    .newBtn {
      width: 72px;
      height: 36px;
      background-color: #219653;
      border: 1px solid #219653;
    }
    .reset {
      width: 72px;
      height: 36px;
      background-color: #f6b439;
      border: 1px solid #f6b439;
    }
    .mapBtn {
      width: 96px;
      height: 36px;
      background-color: #2f80ed;
      border: 1px solid #2f80ed;
    }
  }
  .inquire {
    width: 72px;
    height: 36px;
    margin-top: 2px;
    margin-left: -12px;
  }
  .el-button + .el-button {
    margin-left: 24px;
    // width: 72px;
    height: 36px;
  }
}
/deep/.el-range-separator {
  width: 10%;
}
/deep/.el-range-editor.el-input__inner {
  float: left;
  margin-top: 2px;
}
/deep/.el-date-editor .el-range-separator {
  line-height: 28px;
}
.newly_built {
  margin-top: 18px;
  margin-bottom: 20px;
  .newly_built_btn {
    width: 80px;
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
  .educe {
    background-color: #2f80ed;
    border: #2f80ed;
    width: 72px;
  }
  .export {
    background-color: #f6b439;
    border: #f6b439;
    width: 72px;
  }
  .el-button {
    text-align: center;
    padding: 0;
    height: 36px;
    margin-right: 14px;
  }
}
.money {
  margin-left: 26px;
  /deep/.el-form-item__content {
    width: 244px;
    padding-top: 3px;
  }
  div {
    float: left;
  }
  .zhi {
    width: 44px;
    text-align: center;
  }
  /deep/.el-input {
    width: 100px;
  }
  /deep/.el-input__inner {
    padding-left: 25px;
    float: left;
    width: 100px;
    height: 36px;
  }
}
.checkBox {
  width: 100%;
  height: 50px;
  background: #f2f2f2;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  border-radius: 0px;
}
.el-form-item:nth-last-child(3) {
  margin-left: 0;
}
.paging {
  margin-top: 40px;
  margin-left: 15%;
  // margin-left: 610px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #f6b439;
}

/deep/.el-table th,
.el-table tr {
  text-align: center;
}
/deep/.el-table td,
.el-table th.is-leaf {
  text-align: center;
}
.QuickMark {
  width: 50px;
  height: 36px;
  margin-left: 50%;
  transform: translateX(-50%);
}
.terrace {
  margin-left: 124px;
  height: 40px;
  margin-bottom: 15px;
  .terrace_left,
  .terrace_center,
  .terrace_right {
    font-size: 14px;
    line-height: 40px;
    float: left;
  }
  .terrace_left {
    img {
      width: 40px;
      height: 40px;
    }
    margin-right: 71px;
  }
  .terrace_center {
    margin-right: 47px;
  }
}
.terrace_title {
  margin-top: 10px;
  margin-left: 124px;
  height: 40px;
  .terrace_title {
    float: left;
    line-height: 40px;
  }
}
/deep/.el-table__expanded-cell {
  padding: 15px 50px;
}
.dialog-footer {
  .add_new_btn {
    margin-left: 24px;
    width: 72px;
    height: 36px;
    background-color: #f6b439;
    border: 1px solid #f6b439;
    box-sizing: border-box;
    border-radius: 4px;
  }
  .cancel {
    width: 72px;
    height: 36px;
    background-color: #f2f2f2;
    border: 1px solid #e1e1e1;
    box-sizing: border-box;
    border-radius: 4px;
  }
}
.el-dialog__header {
  padding: 30px;
  font-size: 20px;
}
/deep/.el-dialog__body {
  padding: 30px 60px;
}
/deep/.el-dialog__footer {
  padding: 10px 60px 44px;
}
.landlord {
  margin-top: 50px;
  .landlord_title {
    display: flex;
    height: 40px;
    justify-content: space-between;
    border-bottom: 1px solid #e1e1e1;
  }
  .title_list {
    height: 60px;
    line-height: 60px;
    position: relative;
    border-bottom: 1px solid #e1e1e1;
    .list {
      position: absolute;
      left: 0;
    }
    .list:nth-child(2) {
      left: 183px;
    }
    .list:nth-child(3) {
      left: 378px;
    }
    .list:nth-child(4) {
      left: 578px;
    }
  }
}
/deep/.el-tabs__active-bar {
  background-color: #f6b439;
}
/deep/.el-tabs__item.is-active {
  color: #f6b439;
}
/deep/.el-tabs__item:hover {
  color: #f6b439;
}
.AddLabel {
  width: 100%;
  min-height: 42px;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  margin-bottom: 24px;
  .el-tag.el-tag--warning {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }
}
.select_list {
  padding: 20px;
  width: 100%;
  min-height: 450px;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  .el-checkbox {
    margin-bottom: 30px;
    width: 85px;
    margin-right: 40px;
  }
}
.select_list_title {
  margin-bottom: 20px;
}
.select_list_tree {
  float: left;
  width: 240px;
}
.select_list_tree_box {
  float: right;
  width: 190px;
  padding-left: 20px;
  min-height: 402px;
}
</style>
